import axios from "axios";
import { handlerError } from "utils";
import { PrivateRoutes } from "config/routes/routes";

export const getConfig = async () => {
    try {
        const res = await axios.get("/config");
        const { data } = res;
        const menu = createMenu(data.menu);
        menu.splice(2, 0, {
            "url": "/extract",
            "external": false,
            "context": "extract",
            "label": "Extrato Geral"
        });
        if (!menu.some((item) => item && item.context === "breakage")) {
            menu.push({
                url: "/breakage",
                external: false,
                context: "breakage",
                label: "Breakage",
            });
        }
        const internalTransferIndex = menu.findIndex((item) => item && item.context === "internal-transfers");
        if (internalTransferIndex >= 0) {
            const [internalTransfer] = menu.splice(internalTransferIndex, 1);
            const homeIndex = menu.findIndex((item) => item && item.context === "home");
            menu.splice(homeIndex + 1, 0, internalTransfer);
        }
        return {
            menu,
            system: data.system
        }
    } catch (ex) {
        handlerError(ex);
    }
}

function createMenu(menu) {
    return menu.map(x => {
        const route = PrivateRoutes.filter(r => r.context === x.navigationContext);
        if (route.length > 0) {
            return { url: route[0].url, external: false, context: route[0].context, label: route[0].label }
        }
    });
}
